// Data helper utilities

export function getFieldValue(data: any, fieldPath: string): any {
	if (!data || !fieldPath) return undefined;

	// Custom fields are aliased flat on the row by the backend
	if (fieldPath.startsWith('cf:')) {
		return data[fieldPath];
	}

	// Handle dot notation for nested fields
	const parts = fieldPath.split('.');
	let value = data;

	for (const part of parts) {
		if (value == null) return undefined;
		value = value[part];
	}

	return value;
}

export function setFieldValue(data: any, fieldPath: string, value: any): any {
	if (!data || !fieldPath) return data;

	const parts = fieldPath.split('.');
	const result = { ...data };
	let current = result;

	for (let i = 0; i < parts.length - 1; i++) {
		const part = parts[i];
		if (!part) continue;
		if (!current[part]) {
			current[part] = {};
		}
		current = current[part];
	}

	const lastPart = parts[parts.length - 1];
	if (lastPart) {
		current[lastPart] = value;
	}
	return result;
}
